import { useSpring, animated as a } from 'react-spring';
import playerStyles from './player.module.css';

const SpringIn = ({ children, onClose }) => {
  const animatedProps = useSpring({
    from: {
      transform: 'translateX(100%)',
      opacity: 0
    },
    to: {
      transform: 'translateX(0%)',
      opacity: 1
    },
    config: {
      tension: 200,
      friction: 26,
      mass: 1
    }
  });

  // Backdrop animation
  const backdropSpring = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 300 }
  });

  return (
    <>
      <a.div
        className={playerStyles.backdrop}
        style={backdropSpring}
        onClick={onClose}
      />
      <a.div className={playerStyles.container} style={animatedProps}>
        {children}
      </a.div>
    </>
  );
};

export default SpringIn;